class SpendInputFlat {
    towerId: number;
    roleId: number;
    locationId: number;
    spend:number;
}

export default SpendInputFlat;